/**
 * CUSTOM
 * This code has been developed for this solution.
 */
import { QueryData, ResponseData } from "../services/network/NetworkTypes";
import Proof from "./Proof";

export default class Step {
  constructor(
    public id: string,
    public title: string,
    public is_multiple: boolean,
    public is_mandatory: boolean,
    public is_required_share_all: boolean,
    public presentation_configuration_id: string,
    public presentation_configuration: Proof,
    public integration_configuration: string,
    public order: number,
    public created: Date,
    public modified: Date
  ) {}

  static fromJSON(json: Record<string, any>): Step {
    /*
   {
      "id": "497f6eca-6276-4993-bfeb-53cbbbba6f08",
      "title": "string",
      "is_multiple": true,
      "is_mandatory": true,
      "is_required_share_all":true,
      "presentation_configuration_id": "string",
      "presentation_configuration": {
        "id": "string",
        "created": "2019-08-24T14:15:22Z",
        "modified": "2019-08-24T14:15:22Z",
        "subject_identifier": "string",
        "configuration": { },
        "extended": true
      }
      "integration_configuration": "bb08bb65-1881-4e59-9db4-e033c2b46e83",
      "order": -2147483648,
      "created": "2019-08-24T14:15:22Z",
      "modified": "2019-08-24T14:15:22Z"
    }
 * */

    return new Step(
      json.id,
      json.title,
      json.is_multiple,
      json.is_mandatory,
      json.is_required_share_all,
      json.presentation_configuration.id,
      new Proof(
        json.presentation_configuration.id ?? "",
        json.presentation_configuration.subject_identifier ?? "",
        json.presentation_configuration.name ?? "",
        json.presentation_configuration.configuration?.requested_attributes ??
          [],
        new Date(json.presentation_configuration.created),
        new Date(json.presentation_configuration.modified)
      ),
      json.integration_configuration,
      json.order,
      json.created,
      json.modified
    );
  }

  toJSON(): StepUpdateData {
    return {
      id: this.id,
      title: this.title,
      presentation_configuration_id: this.presentation_configuration_id,
      presentation_configuration: this.presentation_configuration,
      integration_configuration: this.integration_configuration,
      is_multiple: this.is_multiple,
      is_mandatory: this.is_mandatory,
      is_required_share_all: this.is_required_share_all,
      order: this.order,
    };
  }
}

export type StepCreateData = {
  id?: string;
  presentation_configuration_id?: string;
  presentation_configuration?: Proof;
  integration_configuration?: string;
  title: string;
  is_multiple: boolean;
  is_mandatory: boolean;
  is_required_share_all: boolean;
  order: number;
};

export type StepUpdateData = Partial<StepCreateData>;

export type StepDataFilter = "search" | "integration_configuration";

// Backend keys you can sort with
export type StepDataOrder = "title" | "created";

// This will help transform the sorting from local to backend keys.
export const stepDataOrderTransform: Record<string, StepDataOrder> = {
  title: "title",
  created: "created",
};

// These are the keys used for table listings
export type StepDataTableFields = keyof typeof stepDataOrderTransform;

export type StepQueryData = QueryData<StepDataFilter, StepDataOrder>;

export type StepResponseData = ResponseData<
  Step,
  StepDataFilter,
  StepDataOrder
>;
